<script>
  export let title;
  export let subtitle;
</script>

<div class="px-8 py-12 lg:px-16">
  <h2
    class="text-21 text-center font-medium mb-6 md:text-27 lg:text-35
    lg:text-left">
    {title}
  </h2>
  <h3
    class="text-20 text-center font-light px-4 md:text-23 md:px-32 lg:text-left
    lg:font-normal lg:px-0">
    {subtitle}
  </h3>
</div>



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/CalculatorHeader.svelte